import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import {
  Alert,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form1120sSchB = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="IRS Schedule B (Form 1120-S): Ownership & Accounting Info"
          description="Learn how to complete Schedule B (Form 1120-S) to disclose your S corporation’s ownership, accounting methods, shareholder loans, and IRS filing requirements."
          keywords=""
          canonical="resources/business-tax/schedule-b/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          IRS{' '}
          <span className="highlight-container">
            <span className="highlight">Schedule B</span>
          </span>{' '}
          (Form 1120-S): Ownership, Accounting Methods & Other Information
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  component="article"
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/schedule-b/"
                  />
                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    component="h2"
                    itemProp="headline"
                    variant="h4"
                    sx={{
                      fontWeight: 600,
                      mb: 0.8,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    Schedule B (Form 1120-S) at a glance
                  </Typography>

                  <Box
                    component="ul"
                    itemScope
                    itemType="https://schema.org/ItemList"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="1" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand the purpose of Schedule B (Form 1120-S)
                        </strong>{' '}
                        and how it collects important information about your S
                        corporation's ownership, accounting methods, business
                        activities, tax elections, and IRS reporting
                        requirements.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="2" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Learn who must complete Schedule B
                        </strong>{' '}
                        and how filing requirements apply based on your
                        corporation's assets, receipts, shareholder structure,
                        foreign activities, and other disclosure obligations.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="3" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Explore how to complete Schedule B line by line,
                        </strong>{' '}
                        including accounting methods, business activity codes,
                        ownership in other entities, shareholder information,
                        digital assets, Form 1099 reporting, and other IRS
                        disclosure questions.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="4" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand when additional IRS forms and schedules are
                          required,
                        </strong>{' '}
                        such as Schedule B-1, Form 8990, Form 8996, Form 8281,
                        and other supporting attachments based on your answers.
                      </span>
                    </li>
                  </Box>
                </Box>
                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ mb: 0 }}
                >
                  <Box>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      <strong style={{ fontWeight: 600 }}>
                        {' '}
                        Schedule B (Form 1120-S)
                      </strong>{' '}
                      collects key information about your S corporation's
                      business activities, ownership, tax elections, reporting
                      obligations, and other IRS disclosure requirements.
                      Answering these questions accurately helps determine
                      whether you must file additional forms, attach supporting
                      schedules, or report specific tax-related transactions.
                    </Typography>
                  </Box>
                  <Box
                    sx={{ mb: 1, textAlign: { xs: 'center', md: 'left' } }}
                  />
                </Stack>
                <Box
                  sx={{
                    pt: 0,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents</b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whatis" sx={{ color: '#0202ff' }}>
                          What Is IRS Schedule B (Form 1120-S)?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#how" sx={{ color: '#0202ff' }}>
                          How Schedule B Differs from Other Schedules
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whomust" sx={{ color: '#0202ff' }}>
                          Who Must Complete Schedule B?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#filing" sx={{ color: '#0202ff' }}>
                          Filing Deadlines
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#step" sx={{ color: '#0202ff' }}>
                          Step-by-Step Breakdown of Schedule B (Form 1120-S)
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#common" sx={{ color: '#0202ff' }}>
                          Common Mistakes to Avoid
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#best" sx={{ color: '#0202ff' }}>
                          Best Practices for Schedule B Compliance
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#faqs" sx={{ color: '#0202ff' }}>
                          Frequently Asked Questions (FAQs)
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whatis"
                >
                  What is IRS Schedule B (Form 1120-S)?
                </Typography>

                <Typography variant="body1" sx={{ mb: 3 }}>
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    IRS Schedule B (Form 1120-S)
                  </strong>{' '}
                  is an information schedule that accompanies{' '}
                  <Link
                    href="/resources/business-tax/form-1120-s-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 1120-S
                  </Link>
                  . It asks a series of questions about your S corporation's{' '}
                  <strong style={{ fontWeight: 600 }}>
                    ownership, tax status, financial activities, and filing
                    obligations
                  </strong>
                  . Your answers help the IRS determine whether additional
                  forms, disclosures, or reporting requirements apply to your
                  corporation
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="how"
                >
                  How Schedule B Differs From Other Schedules
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 100, fontWeight: 600 }}
                          >
                            Schedule
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            What It Reports
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>Schedule B </TableCell>
                          <TableCell>
                            Ownership, accounting methods, shareholder loans,
                            foreign ownership, and related disclosures (Other
                            Information){' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Schedule L</TableCell>
                          <TableCell>
                            Balance Sheet per Books—assets, liabilities, and
                            shareholder equity at beginning and end of the year
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Schedule M-1 </TableCell>
                          <TableCell>
                            Reconciliation of Income (Loss) per Books with
                            taxable income reported on Form 1120-S
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Schedule M-2 </TableCell>
                          <TableCell>
                            Analysis of Accumulated Adjustments Account (AAA)
                            and other retained earnings adjustments
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="whomust"
                >
                  Who Must Complete Schedule B?
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Every S corporation filing{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1120-s/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 1120-S
                  </Link>{' '}
                  must complete Schedule B if they:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Have total assets of{' '}
                    <span style={{ fontWeight: 600 }}> $250,000</span> or more
                    at the end of the tax year, or{' '}
                  </li>
                  <li>Report balance sheet data on Schedule L, or </li>
                  <li>
                    Have foreign transactions, shareholder loans, or
                    related-party activities.{' '}
                  </li>
                </Box>

                <Typography variant="body1" sx={{ mb: 3 }}>
                  If your corporation has total receipts and assets under
                  <span style={{ fontWeight: 600 }}> $250,000,</span> you may be
                  exempt from completing Schedule L and certain parts of
                  Schedule B, but you must still disclose relevant ownership and
                  accounting method details on Schedule B.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="filing"
                >
                  Filing Deadlines
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Schedule B must be filed{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    alongside Form 1120-S
                  </span>{' '}
                  by the S corporation’s tax filing deadline.
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Entity Type
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Main Return
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Filing Deadline (Tax Year 2025)
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Extension Form
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>S Corporations </TableCell>
                          <TableCell>Form 1120-S </TableCell>
                          <TableCell>March 16, 2026</TableCell>
                          <TableCell>
                            {' '}
                            <Link
                              href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 7004
                            </Link>{' '}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="step"
                >
                  Step-by-Step Breakdown of Schedule B (Form 1120-S)
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Complete Schedule B by answering each question that applies to
                  your{' '}
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    S corporation for the tax year.
                  </strong>{' '}
                  Your responses help the IRS determine whether additional
                  schedules, forms, or disclosures are required with{' '}
                  <Link
                    href="https://www.irs.gov/pub/irs-pdf/f1120s.pdf"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 1120-S
                  </Link>
                  .
                </Typography>
                <picture>
                  <source srcSet="/assets/images/f1120s-schb-other-line1-img.webp" />
                  <source srcSet="/assets/images/f1120s-schb-other-line1-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f1120s-schb-other-line1-img.png"
                    loading="lazy"
                    alt="Schedule B (Form 1120-S) showing other information section, lines 1 through 4b"
                    width={760}
                    height={454}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 1: Accounting Method
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Select the accounting method your S corporation uses to
                    report income and expenses.
                  </li>
                  <li>
                    {' '}
                    Check{' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      Cash, Accrual,
                    </strong>{' '}
                    or <strong style={{ fontWeight: 600 }}>Other</strong> if you
                    use a different IRS-approved method. If you choose Other,
                    specify the accounting method used.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 2a – Business Activity
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter your corporation's primary business activity using the
                  appropriate IRS Principal Business Activity (PBA) code. Choose
                  the code that best matches the business activity that
                  generates most of your revenue.
                </Typography>

                <Alert
                  icon={false}
                  severity="warning"
                  sx={{
                    mt: 0,
                    mb: 4,
                    backgroundColor: '#EDCBF8',
                    borderLeft: '3px solid #6D207D',
                    color: '#111',
                  }}
                >
                  <b>Example:</b>
                  <i>
                    {' '}
                    If you operate a non-store retail business, select the PBA
                    code based on the primary product
                  </i>
                </Alert>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 2b – Product or Service
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Describe the main product your corporation sells or the
                  primary service it provides. Use a clear and specific
                  description that accurately reflects your business operations.
                </Typography>

                <Alert
                  icon={false}
                  severity="warning"
                  sx={{
                    mt: 0,
                    mb: 4,
                    backgroundColor: '#EDCBF8',
                    borderLeft: '3px solid #6D207D',
                    color: '#111',
                  }}
                >
                  <b>Example:</b>
                  <i>
                    {' '}
                    "Software Development", "Restaurant Services",
                    "Construction", or "Retail Clothing".
                  </i>
                </Alert>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 3 – Shareholders That Are Entities
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Select <strong style={{ fontWeight: 600 }}> "Yes"</strong>{' '}
                    if, at any time during the tax year, any shareholder was a
                    disregarded entity, trust, estate, nominee, or similar
                    entity.
                  </li>
                  <li>
                    If <strong style={{ fontWeight: 600 }}>"Yes"</strong>,
                    attach{' '}
                    <strong style={{ fontWeight: 600 }}>Schedule B-1</strong>{' '}
                    with the required shareholder information. Otherwise, check
                    <strong style={{ fontWeight: 600 }}> "No"</strong>.
                  </li>
                </Box>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{
                    mt: 0,
                    mb: 4,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                    fontStyle: 'italic',
                  }}
                >
                  <b>Note:</b> Individual shareholders alone do not require
                  Schedule B-1 unless they hold the stock through one of these
                  entity types
                </Alert>

                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 4a – Ownership in Other Corporations
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Select <strong style={{ fontWeight: 600 }}>"Yes"</strong> if
                    your S corporation directly owned{' '}
                    <strong style={{ fontWeight: 600 }}> 20% or more,</strong>{' '}
                    or directly or indirectly owned{' '}
                    <strong style={{ fontWeight: 600 }}> 50% or more</strong>,
                    of another domestic or foreign corporation at the end of the
                    tax year.
                  </li>
                  <li>
                    If <strong style={{ fontWeight: 600 }}>"Yes"</strong>,
                    provide the corporation's name, EIN (if available), country
                    of incorporation, ownership percentage, and{' '}
                    <strong style={{ fontWeight: 600 }}> QSub</strong> election
                    date if applicable.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 4b – Ownership in Partnerships or Trusts
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Select <strong style={{ fontWeight: 600 }}>"Yes"</strong> if
                    your corporation directly owned{' '}
                    <strong style={{ fontWeight: 600 }}>20% or more,</strong> or
                    directly or indirectly owned{' '}
                    <strong style={{ fontWeight: 600 }}> 50% or more,</strong>{' '}
                    of a partnership's profits, losses, or capital, or a trust's
                    beneficial interest.
                  </li>
                  <li>
                    If <strong style={{ fontWeight: 600 }}>"Yes",</strong> enter
                    the entity's name, EIN (if available), entity type, country
                    of organisation, and the maximum ownership percentage.
                  </li>
                </Box>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{
                    mt: 0,
                    mb: 4,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                    fontStyle: 'italic',
                  }}
                >
                  <b>Note:</b> When calculating ownership, include any ownership
                  interests attributed under the IRS constructive ownership
                  rules.
                </Alert>
                <picture>
                  <source srcSet="/assets/images/f1120s-schb-other-line5-img.webp" />
                  <source srcSet="/assets/images/f1120s-schb-other-line5-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f1120s-schb-other-line5-img.png"
                    loading="lazy"
                    alt="Schedule B (Form 1120-S) showing other information section, lines 5a through 11b"
                    width={760}
                    height={475}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 5a – Restricted Stock
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Indicate whether the corporation had any outstanding
                    restricted stock at the end of the tax year.{' '}
                  </li>
                  <li>
                    If <strong style={{ fontWeight: 600 }}> "Yes"</strong>,
                    report both the total number of restricted shares and the
                    total number of non-restricted shares outstanding.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 5b – Stock Options, Warrants, or Similar Instruments
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Select <strong style={{ fontWeight: 600 }}>"Yes"</strong> if
                    the corporation had any outstanding stock options, warrants,
                    or similar instruments at year-end.
                  </li>
                  <li>
                    If <strong style={{ fontWeight: 600 }}>"Yes"</strong>,
                    report the total shares currently outstanding and the total
                    shares that would be outstanding if all instruments were
                    exercised.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 6 – Form 8918 (Material Advisor Disclosure Statement)
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Select <strong style={{ fontWeight: 600 }}>"Yes"</strong> if
                    your corporation has filed or is required to file Form 8918
                    to disclose information about a reportable transaction.
                  </li>
                  <li>
                    If this doesn't apply to your business, select{' '}
                    <strong style={{ fontWeight: 600 }}>"No"</strong>.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 7 – Publicly Offered Debt Instruments
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Check the box if your corporation issued{' '}
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    publicly offered debt instruments
                  </strong>{' '}
                  with{' '}
                  <strong style={{ fontWeight: 600 }}>
                    original issue discount (OID)
                  </strong>{' '}
                  during the tax year. If checked, you may also need to file{' '}
                  <Link
                    href="https://www.irs.gov/pub/irs-access/f8281_accessible.pdf"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 8281
                  </Link>
                  .
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{
                    mt: 0,
                    mb: 4,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                    fontStyle: 'italic',
                  }}
                >
                  <b>Note:</b> This requirement usually applies to corporations
                  that issue public debt securities. Most privately owned S
                  corporations can leave this box unchecked.
                </Alert>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 8 – Net Unrealized Built-In Gain
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Complete this line only if your corporation was previously
                  taxed as a{' '}
                  <strong style={{ fontWeight: 600 }}> C corporation</strong>{' '}
                  before electing S corporation status or acquired assets from a
                  C corporation. Enter the corporation's{' '}
                  <strong style={{ fontWeight: 600 }}>
                    net unrealized built-in gain
                  </strong>
                  , reduced by any built-in gains recognized in prior years.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{
                    mt: 0,
                    mb: 4,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                    fontStyle: 'italic',
                  }}
                >
                  <b>Note:</b> This amount may affect the corporation's built-in
                  gains tax under{' '}
                  <strong style={{ fontWeight: 600 }}> IRC Section 1374</strong>
                  . If your corporation has multiple asset pools, attach a
                  separate statement showing the calculation for each pool.
                </Alert>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 9 – Section 163(j) Election
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Select <strong style={{ fontWeight: 600 }}>"Yes"</strong> if
                  your corporation has an election in effect to exclude a
                  qualifying{' '}
                  <strong style={{ fontWeight: 600 }}>
                    real property trade or business
                  </strong>{' '}
                  or farming business from the business interest expense
                  limitation under{' '}
                  <strong style={{ fontWeight: 600 }}>Section 163(j)</strong>.
                  Otherwise, select{' '}
                  <strong style={{ fontWeight: 600 }}>"No."</strong>
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{
                    mt: 0,
                    mb: 4,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                    fontStyle: 'italic',
                  }}
                >
                  <b>Note:</b> This election is{' '}
                  <strong style={{ fontWeight: 600 }}> irrevocable</strong> and
                  requires certain assets to be depreciated using the
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    Alternative Depreciation System (ADS)
                  </strong>
                  .
                </Alert>

                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 10 – Form 8990 Filing Requirement
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Determine whether your corporation meets any of the listed
                    conditions related to{' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      business interest expense.
                    </strong>{' '}
                  </li>
                  <li>
                    If you select{' '}
                    <strong style={{ fontWeight: 600 }}>"Yes"</strong> to any
                    condition, complete and attach{' '}
                    <Link
                      href="https://www.irs.gov/pub/irs-pdf/f8990.pdf"
                      target="_blank"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form 8990
                    </Link>{' '}
                    with your return.{' '}
                  </li>
                </Box>

                <Alert
                  icon={false}
                  severity="warning"
                  sx={{
                    mt: 0,
                    mb: 4,
                    backgroundColor: '#EDCBF8',
                    borderLeft: '3px solid #6D207D',
                    color: '#111',
                  }}
                >
                  <b>Example:</b>
                  <i>
                    {' '}
                    A corporation with average annual gross receipts of{' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      more than $31 million,
                    </strong>{' '}
                    tax shelters with business interest expense, or businesses
                    that receive excess business interest expense from a
                    pass-through entity generally must file{' '}
                    <strong style={{ fontWeight: 600 }}> Form 8990</strong>.
                  </i>
                </Alert>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 11 – Small Corporation Exception
                </Typography>
                <Typography variant="body1" sx={{ mb: 0 }}>
                  Select <strong style={{ fontWeight: 600 }}>"Yes"</strong> if
                  both of the following apply:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Total receipts for the tax year were less than{' '}
                    <strong style={{ fontWeight: 600 }}>$250,000</strong>.{' '}
                  </li>
                  <li>
                    Total assets at the end of the tax year were less than{' '}
                    <strong style={{ fontWeight: 600 }}>$250,000</strong>.{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If both conditions are met, the corporation is not required to
                  complete{' '}
                  <strong style={{ fontWeight: 600 }}>
                    Schedules L and M-1.
                  </strong>
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{
                    mt: 0,
                    mb: 4,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                    fontStyle: 'italic',
                  }}
                >
                  <b>Note:</b> Total receipts include gross receipts, other
                  income, rental income, and certain gains reported throughout
                  the tax return, not just sales revenue.
                </Alert>
                <picture>
                  <source srcSet="/assets/images/f1120s-schb-other-info-img.webp" />
                  <source srcSet="/assets/images/f1120s-schb-other-info-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f1120s-schb-other-info-img.png"
                    loading="lazy"
                    alt="Schedule B (Form 1120-S) showing other information section, lines 12 through 17"
                    width={760}
                    height={208}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 12 – Cancellation or Reduction of Non-Shareholder Debt
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Select <strong style={{ fontWeight: 600 }}>"Yes"</strong> if
                  the corporation had any non-shareholder debt that was
                  cancelled, forgiven, or modified during the tax year in a way
                  that reduced the principal amount owed. If "Yes," enter the
                  amount of the principal reduction.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{
                    mt: 0,
                    mb: 4,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                    fontStyle: 'italic',
                  }}
                >
                  <b>Note:</b> This question does not include debt owed to
                  shareholders. Only debt owed to outside parties should be
                  reported here.
                </Alert>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 13 – Termination or Revocation of QSub Election
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Select <strong style={{ fontWeight: 600 }}>"Yes"</strong> if a
                  qualified subchapter S subsidiary{' '}
                  <strong style={{ fontWeight: 600 }}>(QSub)</strong> election
                  was terminated or revoked during the tax year.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  If <strong style={{ fontWeight: 600 }}>"Yes,"</strong> refer
                  to the IRS rules for reporting requirements after the
                  termination or revocation.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 14a – Payments Requiring Form 1099 Filing
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Select <strong style={{ fontWeight: 600 }}>"Yes"</strong> if
                  the corporation made any payments during the tax year that
                  require filing one or more{' '}
                  <strong style={{ fontWeight: 600 }}>Form 1099</strong>{' '}
                  information returns. Otherwise, select{' '}
                  <strong style={{ fontWeight: 600 }}>"No."</strong>
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{
                    mt: 0,
                    mb: 4,
                    backgroundColor: '#EDCBF8',
                    borderLeft: '3px solid #6D207D',
                    color: '#111',
                  }}
                >
                  <b>Example:</b>
                  <i>
                    {' '}
                    Payments to independent contractors, certain service
                    providers, or other recipients may require Form 1099
                    reporting.
                  </i>
                </Alert>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 14b – Filing Required Form 1099s
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  If you Selected{' '}
                  <strong style={{ fontWeight: 600 }}> "Yes"</strong> to Line
                  14a, indicate whether the corporation filed or will file all
                  required{' '}
                  <strong style={{ fontWeight: 600 }}> Form 1099s</strong> for
                  those payments.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 15 – Qualified Opportunity Fund (QOF) Certification
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Select <strong style={{ fontWeight: 600 }}>"Yes"</strong> if
                  the corporation intends to self-certify as a
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    Qualified Opportunity Fund (QOF)
                  </strong>
                  . If "Yes," attach{' '}
                  <strong style={{ fontWeight: 600 }}>Form 8996</strong> and
                  enter the amount reported on Form 8996, Line 15.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{
                    mt: 0,
                    mb: 4,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                    fontStyle: 'italic',
                  }}
                >
                  <b>Note:</b> A corporation must file Form 1120-S and attach
                  Form 8996 even if it has no income or expenses to report for
                  the QOF.
                </Alert>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 16 – Digital Assets
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Select <strong style={{ fontWeight: 600 }}>"Yes"</strong> if
                  the corporation received, sold, exchanged, transferred, or
                  otherwise disposed of any digital asset or financial interest
                  in a digital asset during the tax year. Otherwise, select{' '}
                  <strong style={{ fontWeight: 600 }}>"No."</strong>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Examples of digital asset transactions include:
                </Typography>
                <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                  <li>
                    Receiving cryptocurrency as payment for goods or services.
                  </li>
                  <li>
                    Selling or exchanging cryptocurrency for another digital
                    asset.
                  </li>
                  <li>
                    Receiving digital assets through mining, staking, or similar
                    activities.
                  </li>
                </Box>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{
                    mt: 0,
                    mb: 4,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                    fontStyle: 'italic',
                  }}
                >
                  <b>Note:</b> Simply holding digital assets in a wallet or
                  transferring digital assets between wallets owned by the
                  corporation generally does not require to select "Yes"
                </Alert>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Line 17 – Reserved for Future Use
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  No entry is required for this line. It is reserved by the IRS
                  for future updates or reporting requirements.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="common"
                >
                  Common Mistakes to Avoid
                </Typography>

                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 350, fontWeight: 600 }}
                          >
                            Mistake
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Impact
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            Failing to disclose all ownership details
                          </TableCell>

                          <TableCell>IRS audits and penalties</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Omitting shareholder loan disclosures
                          </TableCell>

                          <TableCell>
                            Tax compliance issues, penalties
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Incorrect accounting method reporting
                          </TableCell>

                          <TableCell>
                            Errors in tax return and IRS inquiries
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Not attaching required schedules (e.g., Schedule
                            B-1)
                          </TableCell>

                          <TableCell>Return rejections or delay</TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Reporting inconsistent information with Schedule L
                            and M schedules
                          </TableCell>

                          <TableCell>Return inquiries or audits</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="best"
                >
                  Best Practices for Schedule B Compliance
                </Typography>
                <Box component="ul" sx={{ mb: 4, '& li': { mb: 1.2 } }}>
                  <li>
                    Maintain accurate bookkeeping and document ownership
                    throughout the year.
                  </li>
                  <li>
                    Ensure all answers on Schedule B align with related
                    schedules (L, M-1, M-2).
                  </li>
                  <li>
                    Transparently record and report all shareholder loans and
                    advances.
                  </li>
                  <li>
                    Review past filings to maintain consistent accounting method
                    disclosure.
                  </li>
                  <li>
                    Use TaxZerone’s guided e-filing platform to automatically
                    include Schedule B with your{' '}
                    <Link
                      href="/business-tax/efile-irs-form-1120-s/"
                      sx={{ color: '#0202ff' }}
                    >
                      Form 1120-S filing
                    </Link>{' '}
                    for maximum accuracy and IRS compliance.{' '}
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="faqs"
                >
                  Frequently Asked Questions (FAQs)
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  1. What is the purpose of Schedule B (Form 1120-S)?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  It discloses your corporation’s ownership, accounting methods,
                  shareholder relationship details, and other critical
                  information supporting the Form 1120-S filing.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  2. Who must file Schedule B?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Every S corporation with assets of $250,000 or more, balance
                  sheet reporting, foreign ownership, or shareholder loans.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  3. Is Schedule B the same as Schedule L or Schedule M-1?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  No. Schedule B is an ownership and accounting questionnaire;
                  Schedule L reports the balance sheet, and Schedule M-1
                  reconciles book income to taxable income.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  4. Can Schedule B be e-filed?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Yes. When you e-file Form 1120-S using TaxZerone, Schedule B
                  is generated and transmitted automatically.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  5. What are the consequences of missing or incomplete Schedule
                  B?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The IRS can reject or issue penalties for incomplete Form
                  1120-S returns missing Schedule B, potentially causing audit
                  risk.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              E-File Your Form 1120-S with Schedule B Using TaxZerone
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              Ensure your S corporation’s ownership, accounting method, and
              shareholder details are fully <br /> and accurately reported for
              IRS compliance and audit readiness.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sschb`}
              >
                Start Filing Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default Form1120sSchB;
